import React from "react";
import { Input, Button, Space } from "antd";

/**
 * 日志过滤器组件的属性类型
 */
export interface LogFiltersProps {
  /** Task ID 过滤器值 */
  taskIdFilter: string;
  /** Task ID 过滤器变化处理函数 */
  onTaskIdFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Request ID 过滤器值 */
  requestIdFilter: string;
  /** Request ID 过滤器变化处理函数 */
  onRequestIdFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Request Header 过滤器值 */
  requestHeaderFilter: string;
  /** Request Header 过滤器变化处理函数 */
  onRequestHeaderFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** 状态码过滤器值 */
  statusFilter: string;
  /** 状态码过滤器变化处理函数 */
  onStatusFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** 应用过滤器按钮点击处理函数 */
  onApplyFilter: () => void;
}

/**
 * 日志过滤器组件
 * @param {LogFiltersProps} props - 组件属性
 * @returns {JSX.Element} React 元素
 */
const LogFilters: React.FC<LogFiltersProps> = ({
  taskIdFilter,
  onTaskIdFilterChange,
  requestIdFilter,
  onRequestIdFilterChange,
  requestHeaderFilter,
  onRequestHeaderFilterChange,
  statusFilter,
  onStatusFilterChange,
  onApplyFilter,
}) => {
  return (
    <Space wrap>
      <Input
        placeholder="Task ID"
        value={taskIdFilter}
        onChange={onTaskIdFilterChange}
        style={{ width: 250 }}
        allowClear
      />
      <Input
        placeholder="Request ID"
        value={requestIdFilter}
        onChange={onRequestIdFilterChange}
        style={{ width: 250 }}
        allowClear
      />
      <Input
        placeholder="Request Header"
        value={requestHeaderFilter}
        onChange={onRequestHeaderFilterChange}
        style={{ width: 250 }}
        allowClear
      />
      <Input
        placeholder="状态码"
        value={statusFilter}
        onChange={onStatusFilterChange}
        style={{ width: 120 }}
        allowClear
      />
      <Button
        style={{ borderColor: "#555555", color: "#ffffff" }}
        onClick={onApplyFilter}
      >
        执行过滤
      </Button>
    </Space>
  );
};

export default LogFilters; 